import Vue from 'vue'

const user = {
    namespaced: true,
    state: {
        user: null
    },

    mutations: {
        SET_USER: (state, user) => {
            state.user = user
        },
    },

    actions: {
    }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js